import {Component, inject} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog'
import {PrintService} from '../../services/print.service'

export interface PreviewResult {
  documentId: string
  status: 'cancel' | 'sign'
}

export interface PreviewInput {
  documentId: string
}

@Component({
  selector: 'spb-preview-dialog',
  templateUrl: './preview-dialog.component.html',
  styleUrls: [],
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class PreviewDialogComponent {
  public data = inject<PreviewInput>(MAT_DIALOG_DATA)
  private readonly printService = inject(PrintService)

  public preview(): void {
    this.printService.getLink(this.data.documentId, false).subscribe()
  }
}
